import React from 'react';
import type { WorkflowNodeProps } from 'flow/service/graph';
import BaseNode from '../BaseNode';

/**
 * ConstructionNodes are invisible nodes that are rendered on the canvas to power
 * different user canvas interactions. They should be rendered wrapped in another
 * node and not by itself.
 */
export default function ConstructionNode({ id, type }: WorkflowNodeProps) {
  return (
    <BaseNode
      id={id}
      type={type}
      construction
      stateStyle={{
        baseBackgroundColor: 'transparent',
      }}
    />
  );
}
